import fornecedoresMenu from './fornecedor/menu'
import financeiroMenu from './financeiro/menu'
import uaiMenu from './uai/menu'
import ucicMenu from './ucic/menu'

const documentoMenuItem = [{
    name: 'Ajuda',
    icon: 'fa fa-book',
    target: '_blank',
    url: "https://sebraepr.sharepoint.com/:f:/r/sites/xerisebraepe/Documentos%20Compartilhados/Unidades/Superintend%C3%AAncia/UAI/PAR%C3%87A?csf=1&web=1&e=RMm97a",
}]

export default {
    name: 'Pleitos',
    url: '/pleitos',
    icon: 'fa fa-book',
    regras: [
        ...fornecedoresMenu.map(r => r.regras),
        ...financeiroMenu.map(r => r.regras),
        ...uaiMenu.map(r => r.regras),
        ...ucicMenu.map(r => r.regras),
    ],
    children: [
        ...fornecedoresMenu, 
        ...financeiroMenu,
        ...uaiMenu,
        ...ucicMenu,
        ...documentoMenuItem  ]
}